import styled from 'styled-components';
import SwimmingPoolSvg from '../../assets/amenities/swimming-pool.svg';

const SwimmingPoolIcon = styled(SwimmingPoolSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.4rem'};
  height: ${props => props.height || '2.4rem'};
  margin: ${props => props.margin};
`;

export default SwimmingPoolIcon;
